<template>
  <div class="not-found-error">
    <h1>404: Not Found</h1>
  </div>
</template>

<script>

import {
  defineComponent,
} from 'vue';

export default defineComponent({
  name: 'NotFoundError',
});

</script>

<style lang="scss"></style>
